
let answerIDs = []
//let scenario
let prompts 



export function initializePromptAnswerGrading(scen) {
    prompts = scen._interventionPrompts
    getAnswerIDs(scen)
    //scenario = scen
    return 'prompt-answer-grading-initialized';
}


function getAnswerIDs(scen){
    if (scen._interventionPromptAnswers){
        let answers = scen._interventionPromptAnswers
        answers.forEach(answer => {
            answerIDs[answer.id] = answer.label})
    }
    if (scen._checkListMetaData){
        let entries = scen._checkListMetaData
        entries.forEach(entry => {
            if (entry.type === "decision-option"){
                answerIDs[entry.id] = entry.label
            }

        })
    }
}

export function getPromptLabel (promptID) {
    let prompt = prompts.find((e) => e.id === promptID)
    if (prompt){
        return prompt.abbrLabel || prompt.label}
    else {return null}
}


export function getPrescribedInvAnswers (interventionID, variantDef, scenario) {
    let intvEntry = scenario.interventionVariantAnswers[interventionID]
    if (!!intvEntry && !isEmpty(intvEntry)){
        if (!!variantDef && !!intvEntry[variantDef]){
            return intvEntry[variantDef]
        }
        else {
            if (intvEntry["{}"]){
                return intvEntry["{}"]
            }
            else {
                return Object.values(intvEntry)[0]  //may have picked the wrong distinguisher so use whatever is defined first for prompt answers
            }
        }
    }
    else {return false}
}

function isEmpty(obj) {
    return Object.keys(obj).length === 0;
}


//eventIn is the observer log event and eventOut is the event
//being annotated during analysis
export function processAssessmentAnswers(eventIn, eventOut, prescribedAnswers, errorStatusVal) {
    if (prescribedAnswers) {
        let answerDetails
        let correctAnswerLabel
        let givenAnswerLabel
        let promptLabel
        eventOut.answerCorrect = true
        let promptID = eventIn.parentID
        let answerID = eventIn.id
        let correctAnswerIDs = prescribedAnswers[promptID]
        correctAnswerLabel = getAnswerLabels(correctAnswerIDs, "one-or-more")
        givenAnswerLabel = getAnswerLabel(answerID)
        promptLabel = getPromptLabel(promptID)
        if (correctAnswerLabel && givenAnswerLabel) {
            let answerCorrect = correctAnswerIDs.includes(answerID)
            //store details of this answer and its grading
            answerDetails = { "promptLabel": promptLabel, "correctAnswer": correctAnswerLabel, "givenAnswer": givenAnswerLabel, "correct": answerCorrect }
            //storing the prompt/answer details
            eventOut.answerDetails[promptID] = answerDetails
            //eventOut.actionDescription = eventOut.actionDescription + ", " + givenAnswerLabel;
            if (!answerCorrect) {
                eventOut.answerCorrect = false;
                eventOut.status = errorStatusVal
                let label = correctAnswerLabel.split(":",1)[0]
                    if (label){
                        label = label.trim().toLowerCase()
                    }
                    else {label = ""}
                if (eventOut.incorrectAnswersFB) {
                    eventOut.incorrectAnswersFB = eventOut.incorrectAnswersFB + ", and " + label;
                }
                else { eventOut.incorrectAnswersFB = label }
            }
        }
    }
    eventOut.id = eventIn.parentID
    eventOut.label = eventIn.parentLabel
    eventOut.actionDescription = eventOut.label
    if (!eventOut.answerCorrect) {
        eventOut.incorrectAnswersFB = "You were incorrect about " + eventOut.incorrectAnswersFB;
    }
    return eventOut
}

//eventIn is the observer log event and eventOut is the event
//being annotated during analysis
export function processInterventionAnswers(eventIn, eventOut, prescribedAnswers, errorStatusVal) {
    if (!!eventIn.answers && prescribedAnswers && !isEmpty(eventIn.answers)) {
        let answerDetails
        let correctAnswerLabel
        let givenAnswerLabel
        let promptLabel
        eventOut.answerCorrect = true
        // move through the given answers and compare to the prescribed answers
        for (const [promptID, answerEntry] of Object.entries(eventIn.answers)) {
            let answerType = getSelectionType(promptID)
            let answerIDs = answerEntry
            //let answerID = answerIDs[0]
            let correctAnswerIDs = prescribedAnswers[promptID]
            correctAnswerLabel = getAnswerLabels(correctAnswerIDs, answerType)
            givenAnswerLabel = getAnswerLabels(answerIDs, answerType)
            promptLabel = getPromptLabel(promptID)
            if (correctAnswerLabel && givenAnswerLabel) {
                //need to extract answerType from somewhere
                let answerCorrectness = evalAnswers(answerIDs, correctAnswerIDs, answerType);
                //store details of this answer and its grading
                answerDetails = { "promptLabel": promptLabel, "correctAnswer": correctAnswerLabel, "givenAnswer": givenAnswerLabel, "correct": answerCorrectness }
                //storing the prompt/answer details
                eventOut.answerDetails[promptID] = answerDetails
                //eventOut.actionDescription = eventOut.actionDescription + ", " + givenAnswerLabel;
                if (!answerCorrectness) {
                    eventOut.answerCorrect = false;
                    eventOut.status = errorStatusVal
                    let label = correctAnswerLabel.split(":",1)[0]
                    if (label){
                        label = label.trim().toLowerCase()
                    }
                    else {label = ""}
                    if (eventOut.incorrectAnswersFB) {
                        eventOut.incorrectAnswersFB = eventOut.incorrectAnswersFB + ", and " + label;
                    }
                    else { eventOut.incorrectAnswersFB = label }
                }
            }
        }
        if (!eventOut.answerCorrect) {
            eventOut.incorrectAnswersFB = "You were incorrect about " + eventOut.incorrectAnswersFB;
        }
    }
    return eventOut
}

function difference(setA, setB) {
    return (Array.from(setA).filter((e) => !setB.includes(e)));
}

const evalAnswers = (answerIDs, prescribedAnswerIDs, answerType) => {   
    switch (answerType) {
        case "one-or-more":
        case "one":
        case "one-or-more-logical-or":
            return (difference(answerIDs, prescribedAnswerIDs).length === 0) 
        case "one-or-more-logical-and":
            return (difference(prescribedAnswerIDs, answerIDs).length === 0)
        default:
            return (difference(answerIDs, prescribedAnswerIDs).length === 0) 
    }
        
};

const getSelectionType = (promptID) => {   
    let prompt = prompts.find((e) => e.id === promptID)
    if (prompt){
        return prompt.selectionType}
}

export const getAnswerLabel = (answerID) => {
    let answerLabel = answerIDs[answerID]
    return (answerLabel || "");
} 

const getAnswerLabels = (answerIDs, answerType) => {
    let answerLabel = ""
    let conjText = ""
    if (typeof (answerIDs) === 'string'){
        answerIDs = [answerIDs]
    }
    switch (answerType) {
        case "one-or-more":
        case "one":
        case "one-or-more-logical-or":
           conjText = " or " 
           break
        case "one-or-more-logical-and":
           conjText = " and "
           break
        default:
            conjText = ", "}
             
    if (answerIDs){
      for (let answerID of answerIDs){
        if (answerLabel === ""){
            answerLabel = getAnswerLabel(answerID)
        }
        else {
            let nextLabel = getAnswerLabel(answerID)
            if (nextLabel !== ""){
                answerLabel = answerLabel + conjText + nextLabel
            }
        }
      }
    }
    return answerLabel;
} 